import { FaChevronDown } from 'react-icons/fa';

const getTextColor = (bgColor) => {
  if (!bgColor || bgColor === 'transparent') return 'black';

  const rgb = bgColor.match(/\d+/g)?.map(Number);
  if (!rgb || rgb.length !== 3) return 'black';

  const [r, g, b] = rgb.map((v) => {
    v /= 255;
    return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
  });
  const luminance = 0.2126 * r + 0.7152 * g + 0.0722 * b;

  return luminance > 0.5 ? 'black' : 'white';
};

const CustomSelect = ({ value, onChange, options, backgroundColor }) => {
  const textColor = getTextColor(backgroundColor);

  return (
    <div className='custom-select-wrapper' style={{ position: 'relative' }}>
      <select
        value={value}
        onChange={onChange}
        className='form-control fs-14'
        style={{
          appearance: 'none',
          paddingRight: '30px',
          backgroundColor,
          color: textColor,
          width: '150px',
        }}
      >
        {options.map(({ label, value }) => (
          <option key={value} value={value}>
            {label}
          </option>
        ))}
      </select>
      <FaChevronDown
        style={{
          position: 'absolute',
          right: '12px',
          top: '50%',
          transform: 'translateY(-50%)',
          pointerEvents: 'none',
          color: textColor,
        }}
      />
    </div>
  );
};

export default CustomSelect;
